import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { toggleKanbanCompanyModal } from '../../actions';

const Container = styled.div`
  z-index: 3;
  overflow-x: auto;
  position: fixed;
  top: 72px;
  right: 0;
  width: 100%;
  max-width: 610px;
  height: 100vh;
  padding: 36px 24px 100px 36px;
  background-color: #fff;

  box-shadow: -14px 0px 15px -11px rgba(66, 68, 90, 0.31);

  .box1 {
    border-bottom: 1px solid #ddd;
    margin-bottom: 16px;
    padding-bottom: 16px;

    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
  }
`;

const STATE = {
  addresses: [],
  stepperClickStep: null,
  stepperClick: false,
};

/* eslint-disable react/prefer-stateless-function */
class SideModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <Container className={this.props.className} innerWidth={window.innerWidth}>{this.props.children}</Container>;
  }
}

SideModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    resetModal() {
      dispatch(toggleKanbanCompanyModal());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SideModal = compose(withConnect, withRouter)(SideModalComp);
